// Company milik user dari /status: objek ber-key compId, kadang array. Murni, nol import.

export function companyList(companies) {
  if (Array.isArray(companies)) return companies;
  return companies ? Object.values(companies) : [];
}

// grup company ada di compGrcp
export function findCompany(companies, compId) {
  const wanted = Number(compId);
  return companyList(companies).find((company) => Number(company?.compId) === wanted) || null;
}
